import React, { useState } from "react";
import { toast } from "sonner";
import { Send, CheckCircle2, XCircle, Archive, RotateCcw } from "lucide-react";
import { api } from "../../lib/api";

const BTN = "inline-flex items-center gap-1.5 px-3 py-2 text-sm rounded-md disabled:opacity-50";

export const PolicyWorkflowActions = ({ policy, can, onChanged }) => {
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState("");
  const act = async (action, body) => {
    setBusy(action);
    try {
      const { data } = await api.post(`/policies/${policy.id}/${action}`, body || {});
      toast.success(`Policy is now ${data.policy.status}`);
      setNote(""); onChanged();
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Action failed");
    } finally { setBusy(""); }
  };
  const s = policy.status;
  const showNote = (s === "Pending Review" && can.approve) || (s !== "Archived" && can.archive);
  return (
    <div className="nv-card p-5 space-y-3" data-testid="policy-workflow">
      <h3 className="text-h3">Workflow</h3>
      <p className="text-xs text-slate-500">Draft → Pending Review → Active → Archived. Readers only ever see the approved (Active) version.</p>
      {policy.rejection_note && <p className="text-xs text-rose-700 bg-rose-50 border border-rose-200 rounded p-2" data-testid="policy-rejection-note">Last rejection: {policy.rejection_note}</p>}
      {showNote && (
        <textarea value={note} onChange={(e) => setNote(e.target.value)} rows={2} placeholder="Optional note (required to reject)"
          className="w-full px-3 py-2 rounded-md border border-slate-200 text-sm" data-testid="policy-workflow-note" />
      )}
      <div className="flex flex-wrap gap-2">
        {s === "Draft" && can.edit && <button onClick={() => act("submit")} disabled={!!busy} className={`${BTN} bg-sky-700 text-white`} data-testid="policy-submit-button"><Send size={14} /> Submit for review</button>}
        {(s === "Pending Review" || s === "Draft") && can.approve && <button onClick={() => act("approve", { note })} disabled={!!busy} className={`${BTN} bg-emerald-600 text-white`} data-testid="policy-approve-button"><CheckCircle2 size={14} /> Approve &amp; activate</button>}
        {s === "Pending Review" && can.approve && <button onClick={() => act("reject", { note })} disabled={!!busy || !note.trim()} className={`${BTN} border border-rose-300 text-rose-700`} data-testid="policy-reject-button"><XCircle size={14} /> Reject to Draft</button>}
        {s !== "Archived" && can.archive && <button onClick={() => act("archive", { note })} disabled={!!busy} className={`${BTN} border border-slate-300 text-slate-700`} data-testid="policy-archive-button"><Archive size={14} /> Archive</button>}
        {s === "Archived" && can.archive && <button onClick={() => act("restore")} disabled={!!busy} className={`${BTN} bg-slate-800 text-white`} data-testid="policy-restore-button"><RotateCcw size={14} /> Restore</button>}
        {!can.edit && !can.approve && !can.archive && <p className="text-xs text-slate-500">You have read access to this policy.</p>}
      </div>
    </div>
  );
};
